import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW1204Component } from './kymw1204.component';

/**
 * メモ編集画面 モジュール設定クラス
 *
 * @export KYMW1204Module
 * @class KYMW1204Module
 */
@NgModule({
  imports: [CommonModule, FormsModule, PlessSharedModule, AppCommonsModule],
  declarations: [KYMW1204Component],
  providers: [],
})
export class KYMW1204Module {}
